
import { monthlyFootnoteFormatter } from 'app/components/questions/base'
import { SingleQuestion } from 'app/components/questions/single'
import { genericChangeCTA } from 'app/containers/PipelineSection/Expenses'
import * as React from 'react'

const TravelQuestionsGroup = () => (
  <SingleQuestion
    header="Travel"
    icon="fa fa-fw fa-ship"
    headerDescription="In this section, you'll be entering travel expenses."
    question={{
      placeholder: 'Enter your current annual travel expenses',
      name: 'expenses.travel.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your annual travel expenses during retirement',
        name: 'expenses.travel.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
        },
        itemFootnoteFormatter: monthlyFootnoteFormatter
      }
    } />
)

const OtherEntertainmentQuestionsGroup = () => (
  <SingleQuestion
    header="Other Entertainment"
    icon="fa fa-fw fa-ship"
    headerDescription="In this section, you'll be entering your expenses for other entertainment."
    question={{
      placeholder: 'Enter your current annual entertainment expenses',
      name: 'expenses.entertainment.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your annual entertainment expenses during retirement',
        name: 'expenses.entertainment.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
      },
      itemFootnoteFormatter: monthlyFootnoteFormatter
    }} />
)

export {
  TravelQuestionsGroup,
  OtherEntertainmentQuestionsGroup,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Entertainment/index.tsx